import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from '@tanstack/react-query'
import { inviteService } from '@/services/InviteService'
import { inviteKeys } from '@/hooks/queryKeys'
import type { InviteDto } from '@lib/dto/invite.dto'
import type { CreateInviteInput } from '@lib/input/invite.input'

/**
 * Send an invite, invalidating the invite list on success so the new invite —
 * and the revocation of any earlier one for the same address, which the API
 * performs server-side — both show up without a manual refetch.
 */
export function useCreateInvite(): UseMutationResult<
  InviteDto,
  Error,
  CreateInviteInput
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (input: CreateInviteInput) => inviteService.create(input),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: inviteKeys.lists() })
    },
  })
}
